import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, Overlay, Popover } from 'react-bootstrap';
import moment from 'moment';

import TimePickerRange from 'components/forms/TimePickerRange';
import IntlTime from 'components/layout/IntlTime';

class FormWorkingHours extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initialValue: props.value || [],
      value: props.value || [],
      targetRef: null,
      showPrompt: false,
      editingIndex: false,
    };

    this.targetRef = React.createRef();
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { showPrompt, targetRef } = this.state;

    if (prevState.targetRef !== targetRef && targetRef !== null && !showPrompt) {
      this.setState({ showPrompt: true, editingIndex: targetRef });
    }
  };

  checkRequired = () => {
    const { meta } = this.props;
    return meta.validate.rules.indexOf('required') !== -1 ? 'required ' : '';
  };

  checkError = () => {
    const { validation } = this.props;
    return validation.valid ? '' : 'has-error ';
  };

  // check if user may read this field
  checkAccess = () => {
    const { meta } = this.props;
    return meta.acl.read;
  };

  // check if user may write to this field
  checkReadOnly = () => {
    const { meta } = this.props;
    return !meta.acl.write;
  };

  onChange = (timeValue, which) => {
    const { name, onChange } = this.props;
    const { editingIndex, value: oldValue } = this.state;

    const value = oldValue.slice();

    const val = timeValue.split(':');
    value[editingIndex][which.toLowerCase()] = parseInt(val[0], 10) + Math.floor((val[1] / 60) * 1000) / 1000;

    this.setState({ value }, () => {
      onChange(name, value);
    });
  };

  listValues = () => {
    const {
      intl: { messages },
      disabled,
      referenceDate,
      emptyMessage,
    } = this.props;
    const { value, targetRef } = this.state;

    const datePrefix = moment(referenceDate || undefined).format('YYYY-MM-DD');

    if (value.length) {
      return value.map((val, i) => {
        const displayStart = <IntlTime date={datePrefix + ' ' + this.formatValue(val.start) + ':00'} />;
        const displayEnd = <IntlTime date={datePrefix + ' ' + this.formatValue(val.end) + ':00'} />;
        const key = i;

        // if the form element is not disabled, show the overlay for current time range
        const onClick =
          !disabled &&
          (() => {
            this.setState({ targetRef: key });
          });

        return (
          <span key={key} ref={key === targetRef && this.targetRef} className="m-r-10 tag label label-info">
            <span onClick={onClick} className="p-r-5">
              {displayStart} - {displayEnd}
            </span>

            {!disabled && (
              <a
                href="#remove"
                onClick={e => {
                  e.preventDefault();
                  this.remove(e, key);
                }}
                className="p-l-5 p-r-5"
              >
                ×
              </a>
            )}
          </span>
        );
      });
    }

    return emptyMessage || messages.closed_please_add_timeframe;
  };

  // values come from database in a float format. we need to format the time in HH:mm
  formatValue = value => {
    const val = value.toString().split('.');
    let hours = parseInt(val[0], 10);
    let minutes = Math.round((value - val[0]) * 60);
    if (hours < 10) {
      hours = '0' + hours.toString();
    }
    if (minutes < 10) {
      minutes = '0' + minutes.toString();
    }
    return hours + ':' + minutes;
  };

  getValueStart = () => {
    const { showPrompt, editingIndex, value } = this.state;

    if (showPrompt) {
      return this.formatValue(value[editingIndex].start);
    }
  };

  getValueEnd = () => {
    const { showPrompt, editingIndex, value } = this.state;

    if (showPrompt) {
      return this.formatValue(value[editingIndex].end);
    }
  };

  addNew = () => {
    const { name, onChange } = this.props;
    const { value: oldValue } = this.state;

    const newWorkingHours = {
      start: '6.5',
      end: '17.5',
    };

    const value = oldValue.slice();
    value.push(newWorkingHours);

    this.setState({ value }, () => {
      onChange(name, value);
    });
  };

  remove = (e, index) => {
    e.stopPropagation();
    e.preventDefault();

    const { name, onChange } = this.props;
    const { value: oldValue } = this.state;

    const value = oldValue.slice();
    value.splice(index, 1);

    this.setState({ value }, () => {
      onChange(name, value);
    });
  };

  checkDisabled = () => {
    const { disabled, meta } = this.props;
    if (disabled) {
      return true;
    }
    if (!meta.acl.write) {
      return true;
    }
    return false;
  };

  render() {
    const { label, disabled, timezone, referenceDate } = this.props;
    const { showPrompt } = this.state;

    return (
      <div
        className={'form-group form-group-default ' + this.checkRequired() + (this.checkDisabled() ? 'disabled ' : '')}
      >
        <label>{label}</label>
        <div className="bootstrap-tagsinput">
          {this.listValues()}

          {!disabled && (
            <Button className="m-l-10" bsSize="xs" onClick={this.addNew}>
              <i className="fa fa-plus" />
            </Button>
          )}
        </div>

        <Overlay
          show={showPrompt}
          target={this.targetRef.current}
          placement="top"
          rootClose
          onHide={() => {
            this.setState({ showPrompt: false, editingIndex: null, targetRef: null });
          }}
        >
          <Popover style={{ maxWidth: 'none' }}>
            <TimePickerRange
              displayTz={timezone}
              valueStart={this.getValueStart()}
              valueEnd={this.getValueEnd()}
              onChange={this.onChange}
              referenceDate={referenceDate}
            />
          </Popover>
        </Overlay>
      </div>
    );
  }
}
FormWorkingHours.defaultProps = {
  referenceDate: undefined, // reference date
  label: 'Working hours',
  name: 'workingWeek', // form field name
  meta: { validate: { rules: '' } },
  validation: { valid: true },
  onChange: () => {},
  emptyMessage: null,
};

export default injectIntl(FormWorkingHours);
